<template>
  <div
    class="v-textarea"
    :class="{ [this.extraClass]: true, ['has-error']: this.errors.length }"
  >
    <label class="v-textarea__label" v-if="label"
      >{{ label }}
      <span v-if="required" class="required">(Required)</span></label
    ><textarea
      :name="name"
      :value="value"
      :placeholder="placeholder"
      @input="emitValue"
      class="v-textarea__input-field"
    ></textarea>
    <div v-for="(error, idx) in errors" :key="idx" class="v-textarea__error">
      {{ error }}
    </div>
  </div></template
>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.component("VTextArea", {
  props: {
    value: VueTypes.string.def(""),
    maxHeight: VueTypes.number.def(300),
    placeholder: VueTypes.string,
    name: VueTypes.string,
    errors: VueTypes.arrayOf(VueTypes.string).def([]),
    label: VueTypes.string,
    extraClass: VueTypes.string.def(""),
    required: VueTypes.bool.def(false)
  },

  methods: {
    emitValue(event) {
      this.$emit("change", event.target.value);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "v-textarea";

.#{$ns} {
}

.#{$ns}__label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  color: $primary-text-color;
  font-family: "Lato-Bold", sans-serif;
  padding-bottom: 14px;
  padding-left: 8px;
  font-weight: 300;
  vertical-align: middle;
  display: inline-block;
  flex-shrink: 0;

  .required {
    font-size: 15px;
    font-family: Lato-Light, sans-serif;
  }
}

.#{$ns}__input-field {
  width: 100%;
  border-radius: 3px;
  min-height: 178px;
  color: #1f1f1f;
  font-size: 15px;
  padding: 10px;
  transition: border-color 0.2s linear;
  border: 1px solid $primary-border-color;
  font-family: "Lato-Regular", sans-serif;

  //disable resize in the corner
  resize: none;

  &:hover,
  &:focus {
    border-color: $primary-color;
    outline: none;
  }
}

.#{$ns}__error {
  width: 100%;
  font-size: 14px;
  padding-top: 7px;
  font-family: Lato-Light, sans-serif;
  text-align: left;

  &:nth-child(1) {
    padding: 0.7em 0.1em;
  }

  &,
  &:focus {
    color: $danger-color;
  }
}

textarea {
  &::placeholder {
    font-family: "Lato-Light", sans-serif;
    font-style: italic;
    font-size: 15px;
    color: #979797;
  }
}

.has-error {
  textarea {
    &,
    &:focus {
      border-color: $danger-color;
    }
    color: $danger-color;
  }
}
</style>
